import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useAuth } from "@/lib/auth";
import axios from "axios";
import { API, useApi } from "@/lib/api";
import { browserTz, currencyFor, detectCountry } from "@/lib/geo";

const Ctx = createContext(null);
export const useApp = () => useContext(Ctx);

export function AppProvider({ children }) {
  const { isSignedIn, isLoaded } = useAuth();
  const api = useApi();
  const [me, setMe] = useState(null);
  const [signupOpen, setSignupOpen] = useState(false);
  const [country, setCountryState] = useState(detectCountry());

  const setCountry = useCallback((cc) => {
    localStorage.setItem("ww_country", cc);
    setCountryState(cc);
  }, []);

  const refreshMe = useCallback(async () => {
    if (!isSignedIn) return setMe(null);
    try {
      let data = await api("get", "/me");
      if (!data.country) {
        const cc = localStorage.getItem("ww_country") || country;
        data = await api("patch", "/me", { country: cc, currency: currencyFor(cc), timezone: browserTz() });
      }
      setMe(data);
      if (data.country) setCountryState(data.country);
    } catch {
      setMe(null);
    }
  }, [api, isSignedIn, country]);

  useEffect(() => {
    if (isLoaded) refreshMe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoaded, isSignedIn]);

  useEffect(() => {
    if (localStorage.getItem("ww_country")) return;
    axios.get(`${API}/geo`).then((r) => { if (r.data.country) setCountryState(r.data.country); }).catch(() => {});
  }, []);

  const value = { me, setMe, refreshMe, signupOpen, openSignup: () => setSignupOpen(true), closeSignup: () => setSignupOpen(false), country, setCountry };
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}
